export const iconFontAwesomeBuildingsHouseMedicalCircleXmark = (
	<i className="fa-solid fa-house-medical-circle-xmark"></i>
);
